export default __webpack_public_path__ + "static/mobile-bg-top-mask-e7b0ddf6ad4232c552eacb0aaa4d34d1.png";